import React from 'react';
import SuperProfileMinimumOverallAssessmentScoreRequiredInput from './SuperProfileMinimumOverallAssessmentScoreRequiredInput';
import SuperProfileMinimumOverallQAndRScoreRequired from './SuperProfileMinimumOverallQAndRScoreRequired';

const SuperMatchBenchmarksInput = () => {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SuperProfileMinimumOverallAssessmentScoreRequiredInput />
        <SuperProfileMinimumOverallQAndRScoreRequired />
      </div>
    </div>
  );
};

export default SuperMatchBenchmarksInput;
